export default {
    modal_id:"#station_prefix_modal",
    generateStationInformationTable(s){
        let html = "<table class='table'>"
        html += "<thead><tr><th>Nome</th><th>Tipo</th><th>Proprietário</th><th>Lat/Lng</th><th>Ugrhi</th><th>Municipio</th></tr></thead>"
        html += "<tbody><tr><td>"+s.station.name+"</td><td>"+s.station_type.name+"</td><td>"+s.station_owner.name+"</td><td>"+s.station.latitude.substring(0,8)+"/"+s.station.longitude.substring(0,8)+"</td><td>"+s.station.ugrhi.name+"</td><td>"+s.station.city.name+"</td></tr></tbody>"
        html += "</table>"
        $("#station_prefix_modal").find('.table-station-informations').html(html)
    },
    setTitle(station_prefix){
        $(this.modal_id).find('.modal-title').html("INFORMAÇÕES DO POSTO: " +station_prefix.prefix)
    },
    isOpen(){
        return $(this.modal_id).is(':visible');;
    },
    open(){
        console.log('abrindo')
        $(this.modal_id).modal('show')
    },
    close(){
        $(this.modal_id).modal('hide')
    }
}